import { render, staticRenderFns } from "./HealthReportSaveSnakebar.vue?vue&type=template&id=cf15be7c&scoped=true&"
import script from "./HealthReportSaveSnakebar.vue?vue&type=script&lang=js&"
export * from "./HealthReportSaveSnakebar.vue?vue&type=script&lang=js&"
import style0 from "./HealthReportSaveSnakebar.vue?vue&type=style&index=0&id=cf15be7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf15be7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
